@if (!!file()) {
  <div
    class="card stick tile-view-card"
    irisDragAndDrop
    [draggable]="!lite"
    [droppable]="false"
    [dragData]="dragData()"
    (dragStart)="dragging.emit(true)"
    (dragEnd)="dragging.emit(false)"
    (dblclick)="openFilePreview()"
    [class.selected-file]="selected"
  >
    <div class="file-checkbox">
      <sk-checkbox
        class="m-0 p-0"
        [formControl]="selectionFormControl"
        data-test="tile-view-file-card-checkbox"
      ></sk-checkbox>
    </div>
    
    <div class="file-actions">
      <ng-template [ngTemplateOutlet]="actionsTemplate" [ngTemplateOutletContext]="{ file: file() }"></ng-template>
    </div>

    <div class="tile-view-file-image-container">
      <div [class.tile-view-card-icon]="!isThumbnailAvailable()">
        @if (isThumbnailAvailable()) {
          <img
            class="card-img-top tile-view-file-image"
            [src]="thumbLink()" alt="File thumbnail"
            (error)="onImgError()"
          >
        } @else {
          <i [ngClass]="fileTypeIfThereIsNoThumbnail()" class="fas fa-3x icon-iris dms-icon-color"></i>
        }
      </div>
    </div>

    <div class="card-body tile-view-card-body">
      <div class="tile-view-card-title text-ellipsis" [matTooltip]="fileName()">
        <i [hidden]="!fileLocked()" class="fas fa-lock lock-icon"></i>
        {{ fileName() }}
      </div>

      <div class="tile-view-card-text">
        {{ updatedOn() | irisTime }}
      </div>
    </div>
  </div>
}
